module.exports = __webpack_public_path__ + "img/Roboto-Light.c7c9289.svg";